import React, { useState } from 'react';
import { Dimensions, StyleSheet, TouchableOpacity, View } from 'react-native';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style';
import { profileAvatarFacials, profileAvatarHats } from '../profileAvatar/ProfileAvatar';
import ProfileAvatarSelectionList from './ProfileAvatarSelectionList';
import { profileAvatarToObject } from '../../helpers/profileAvatar';
import ProfileAvatarStamp from '../profileAvatar/ProfileAvatarStamp';

const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  modal: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.CONTAINER_MARGIN * 3,
    backgroundColor: theme.WHITE_COLOR,
    borderTopColor: theme.GREY_DARKER_COLOR,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
  },
  card: {
    ...(width > 900
      ? {
          flex: '1 0 auto',
          flexDirection: 'row',
          alignItems: 'stretch',
          marginTop: theme.CONTAINER_MARGIN * 2,
          marginBottom: theme.CONTAINER_MARGIN * 2,
          padding: theme.CONTAINER_MARGIN * 2,
        }
      : {
          flex: 1,
          flexDirection: 'column',
          margin: theme.CONTAINER_MARGIN * 0.5,
          padding: theme.CONTAINER_MARGIN,
        }),
    borderWidth: 4,
    borderRadius: theme.BUTTON_BIG_BORDER_RADIUS,
    backgroundColor: theme.GREEN_LIGHT_COLOR,
    maxWidth: 900,
  },
  previewWrapper: {
    width: width > 900 ? '33%' : width * 0.5,
    marginRight: width > 900 ? 20 : 0,
    marginBottom: width > 900 ? 0 : 10,
    ...(width <= 900 && { marginLeft: 'auto', marginRight: 'auto' }),
  },
  preview: {
    width: width > 900 ? '100%' : width * 0.5,
    height: width > 900 ? 'auto' : width * 0.5 * 1.21,
    marginBottom: 10,
  },
  sections: {
    flex: 1,
  },
  sectionButtons: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  sectionButton: {
    backgroundColor: theme.GREEN_DARKER_COLOR,
    borderTopLeftRadius: theme.BUTTON_BORDER_RADIUS,
    borderTopRightRadius: theme.BUTTON_BORDER_RADIUS,
    paddingLeft: 20,
    paddingTop: 10,
    paddingRight: 20,
    paddingBottom: 10,
  },
  sectionButtonActive: {
    backgroundColor: theme.GREEN_WARM_COLOR,
  },
  sectionButtonText: {
    fontSize: theme.FONT_SIZE_HEADLINE * 1.5,
    color: theme.WHITE_COLOR,
  },
  confirmButton: {
    height: 50,
    backgroundColor: theme.GREEN_DARKER_COLOR,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99,
    paddingLeft: 50,
    paddingRight: 50,
    marginBottom: 20,
  },
  confirmText: {
    color: theme.WHITE_COLOR,
    fontSize: 20,
  },
});

export default function ProfileAvatarSelection({
  currentUser: {
    user: { id, avatar },
  },
  updateAvatar,
  onCloseModal,
}) {
  const [section, setSection] = useState('facials');
  const { facial, hat } = profileAvatarToObject(avatar);

  return (
    <View style={styles.modal} testID="profileAvatarSelection">
      <View style={styles.card}>
        <View style={styles.previewWrapper}>
          <ProfileAvatarStamp avatar={avatar} style={styles.preview} seal={false} />
        </View>

        <View style={styles.sections}>
          <View style={styles.sectionButtons}>
            {['Facials', 'Hats'].map((sectionKey) => (
              <TouchableOpacity
                key={sectionKey}
                style={[
                  styles.sectionButton,
                  sectionKey.toLowerCase() === section && styles.sectionButtonActive,
                ]}
                onPress={() => setSection(sectionKey.toLowerCase())}
              >
                <CustomText style={styles.sectionButtonText}>{sectionKey}</CustomText>
              </TouchableOpacity>
            ))}
          </View>

          {section === 'facials' && (
            <ProfileAvatarSelectionList
              items={profileAvatarFacials}
              selected={facial}
              onSelect={(newFacial) => updateAvatar(id, { facial: newFacial })}
            />
          )}

          {section === 'hats' && (
            <ProfileAvatarSelectionList
              items={profileAvatarHats}
              selected={hat}
              onSelect={(newHat) => updateAvatar(id, { hat: newHat })}
            />
          )}
        </View>
      </View>
      <TouchableOpacity style={styles.confirmButton} onPress={onCloseModal}>
        <CustomText style={styles.confirmText}>Done</CustomText>
      </TouchableOpacity>
    </View>
  );
}
